import * as types from '../const/action.types';
import { get } from '../api/_basic';

export function reportsAPPCCIsLoading(bool) {
    return {
        type: types.REPORT_APPCC_IS_LOADING,
        isLoading: bool,
    };
}

export function reportsAPPCCFieldsFetchDataSuccess(items) {
    return {
        type: types.REPORT_APPCC_FETCH_DATA,
        items,
    };
}

export function loadAPPCC(local, from) {
    return async (dispatch) => {
        dispatch(
            reportsAPPCCFieldsFetchDataSuccess({
                from: from,
                local: local,
            }),
        );
        dispatch(reportsAPPCCIsLoading(true));
        try {
            const response = await get(
                `${process.env.REACT_APP_API_REPORT_APPCC}/${local}/${from}`,
            );
            dispatch(reportsAPPCCIsLoading(false));
            if (response.error !== undefined) {
                throw Error(response);
            }
            const field = {
                from: from,
                local: local,
                values: response,
            };
            dispatch(reportsAPPCCFieldsFetchDataSuccess(field));
        } catch (error) {
            dispatch(reportsAPPCCIsLoading(false));
            throw error;
        }
    };
}



// WEBPACK FOOTER //
// ./src/actions/api.reports.appcc.actions.js